import { Component, OnInit } from '@angular/core';
import { ToastsManager } from "ng2-toastr";
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { CommonHelper } from '../../../../shared/helpers/CommonHelper';
import { Company } from '../../../../models/Company.model';
import { Product } from '../../../../models/billing-letter/Product.model';
import { CompaniesService } from '../../../../services/companies.service';
import { OwnerService } from '../../../../services/billing-letter/owner.service';
import { Owner } from '../../../../models/billing-letter/Owner.model';
import { ProductService } from '../../../../services/product.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-company-temporary-create',
    templateUrl: './company-temporary-create.component.html',
    styleUrls: ['./company-temporary-create.component.css']
})
export class CompanyTemporaryCreateComponent implements OnInit {
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    mask = [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
    loading: boolean;
    companyForm: FormGroup;
    commonHelper: CommonHelper = new CommonHelper();
    company: Company = new Company();
    email: String = '';
    emailFiller: String = '';
    products: Product[];
    productsCompany: any[] = [];
    managers: Owner[] = [];

    constructor(private companiesService: CompaniesService,
        private productService: ProductService,
        private ownerService: OwnerService,
        private formBuilder: FormBuilder,
        private router: Router,
        private tostr: ToastsManager) { }

    async ngOnInit() {
        this.loading = true;
        this.companyForm = this.formBuilder.group({
            group: [null, [this.validateSelectOption]],
            ownerName: [null, [this.validateSelectOption]],
            manager: [null, [this.validateSelectOption]],
            email: [null, [Validators.required, Validators.email]],
            emailFiller: [null, [Validators.required, Validators.email]]
        });
        this.products = await this.productService.getAllProducts();
        this.products = _.orderBy(this.products,[product => product.name.toUpperCase()]);
        this.managers = await this.ownerService.getAll();
        this.loading = false;
    }

    async OnSave() {
        try {

            if (this.companyForm.valid) {
                this.company.manager.name = this.managers.find(x => x._id === this.company.manager._id).name;
                this.company.owner.name = this.managers.find(x => x._id === this.company.owner._id).name;

                if(!this.productsValid()){
                    this.tostr.warning('Impossível avançar, há campos obrigatórios nos produtos não preenchidos.');
                } else {
                    this.company.emails = [this.email];

                    const companyTemporary: any = {
                        ...this.company,
                        emailFiller: this.emailFiller,
                        products: this.productsCompany
                    }

                    this.loading = true;
                    let response = await this.companiesService.createTemporaryCompany(companyTemporary);
                    if (response._id) {
                        this.loading = false;
                        this.tostr.success('Um e-mail foi enviado ao responsável comercial para preenchimento dos dados da empresa!', 'Link gerado', { timeOut: 10000 });
                        this.router.navigate(['/companies']);
                    } else {
                        this.loading = false;
                        this.tostr.warning('Erro ao criar registro. Tente novamente!');
                    }
                }
            }
        } catch(err){
            this.loading = false;
            console.log(err);
            this.tostr.warning('Erro ao criar registro. Tente novamente!');
        }
    }

    productsValid(){
        if(this.productsCompany.length > 0){
            for(let prod of this.productsCompany){
                if(prod.name === '' || prod.quantity === 0 || prod.value === 0)
                    return false;
            }
        }
        return true;
    }

    addProduct() {
        this.productsCompany = [
            ...this.productsCompany,
            { name: '', quantity: 0, value: 0, monthly: 'true' }
        ]
    }

    removeProduct(i){
        this.productsCompany.splice(i, 1);
    }

    OnClear() {
        this.company = new Company();
    }

    verifyValidTouched(fieldName) {
        return !this.companyForm.get(fieldName).valid && this.companyForm.get(fieldName).touched;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    verifyDate(date, field) {
        if (!(new RegExp(this.datePattern).test(date))) {
            this.tostr.warning(`Digite uma data válida.`, "Data inválida!");
            this.company[`${field}`] = "";
        }
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0' ||
            control.value == 'undefined' || control.value == undefined)
            return {division: true};
        return null;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/companies/company-temporary/company-temporary-create/company-temporary-create.component.ts